import { DimeAlert, DimeAlertDescription, DimeAlertTitle } from '@nudool/design-system';
import { useRouterState } from '@tanstack/react-router';
import { EyeOffIcon } from 'lucide-react';

import {
  matchAccessRoute,
  missingRouteAccess,
  permissionLabel,
  routeLookups,
} from '../lib/access/index.js';
import { usePermissions } from '../modules/iam/permissions-context.js';

/** Names the permissions a page reads but the caller lacks, so blank or failed sections say why. */
export function MissingLookupsNotice() {
  const { permissions, hasActiveBrandMembership, loading } = usePermissions();
  const pathname = useRouterState({ select: (routerState) => routerState.location.pathname });
  const route = matchAccessRoute(pathname);
  if (loading || !route) return null;

  const { missingPermissions, needsBrandMembership } = missingRouteAccess(route, {
    permissions,
    hasActiveBrandMembership,
  });
  const canOpen = missingPermissions.length === 0 && !needsBrandMembership;
  const missingLookups = routeLookups(route).filter(
    (permission) => !permissions.includes(permission),
  );
  if (!canOpen || missingLookups.length === 0) return null;

  return (
    <DimeAlert variant="info" className="mb-4">
      <EyeOffIcon />
      <DimeAlertTitle>Parts of this page need more access</DimeAlertTitle>
      <DimeAlertDescription>
        Needs {missingLookups.map(permissionLabel).join(', ')}.
      </DimeAlertDescription>
    </DimeAlert>
  );
}
